// extracted by mini-css-extract-plugin
export var footer = "_p1-5";
export var fulfillmentInput = "_p1-0";
export var shipDateInput = "_p1-1";
export var shipmentModal = "_p1-2";
export var shipmentModalContent = "_p1-3";
export var tableContainer = "_p1-4";